/* free-shipping-scratch.js
   Gold foil scratch banner — Indofood Online

   Theme-safe:
     · binds by class, so more than one instance can live on a page
     · re-inits on shopify:section:load / :unload so the theme editor
       doesn't leave a dead canvas behind
     · GA4 event on reveal (gtag is already on the site via home-html) */

(function () {
  'use strict';

  var COLS = 44, ROWS = 22, TOTAL = COLS * ROWS, THRESHOLD = 0.42;
  var instances = [];

  function init(root) {
    if (!root || root.__ffs) return;

    var stage   = root.querySelector('.ffs__stage');
    var canvas  = root.querySelector('.ffs__foil');
    var skip    = root.querySelector('.ffs__skip');
    var posters = Array.prototype.slice.call(root.querySelectorAll('.ffs__scale'));
    if (!stage || !canvas || !posters.length) return;

    var ctx = canvas.getContext('2d');
    var torn = new Set();
    var dpr = 1, W = 0, H = 0, open = false, scratching = false, lastX = 0, lastY = 0;

    /* ── gold foil ─────────────────────────────────────── */
    function paintFoil() {
      var g = ctx.createLinearGradient(0, 0, W, H);
      g.addColorStop(0.00, '#8A6A1E'); g.addColorStop(0.12, '#F6E19A');
      g.addColorStop(0.26, '#C9A227'); g.addColorStop(0.40, '#FFF6D6');
      g.addColorStop(0.55, '#B4871B'); g.addColorStop(0.70, '#F3DC93');
      g.addColorStop(0.84, '#D4AF37'); g.addColorStop(1.00, '#96701A');
      ctx.fillStyle = g;
      ctx.fillRect(0, 0, W, H);

      ctx.lineWidth = 1;
      ctx.strokeStyle = 'rgba(255,248,214,.50)';
      for (var i = 0; i < 28; i++) {
        var y1 = Math.random() * H;
        ctx.beginPath(); ctx.moveTo(0, y1);
        ctx.lineTo(W, y1 + (Math.random() * 26 - 13)); ctx.stroke();
      }
      ctx.strokeStyle = 'rgba(74,54,8,.20)';
      for (var j = 0; j < 20; j++) {
        var y2 = Math.random() * H;
        ctx.beginPath(); ctx.moveTo(0, y2);
        ctx.lineTo(W, y2 + (Math.random() * 32 - 16)); ctx.stroke();
      }

      ctx.save();
      ctx.globalAlpha = 0.11;
      ctx.fillStyle = '#3A2A08';
      ctx.font = '500 ' + (13 * dpr) + 'px "DM Mono", monospace';
      ctx.translate(W / 2, H / 2);
      ctx.rotate(-Math.PI / 9);
      for (var y = -H; y < H; y += 34 * dpr) {
        for (var x = -W; x < W; x += 210 * dpr) ctx.fillText('INDOFOOD ONLINE ·', x, y);
      }
      ctx.restore();

      /* pre-scratched notch: the affordance */
      ctx.globalCompositeOperation = 'destination-out';
      ctx.beginPath();
      ctx.moveTo(0, H * 0.30);
      ctx.lineTo(22 * dpr, H * 0.38);
      ctx.lineTo(0, H * 0.47);
      ctx.closePath(); ctx.fill();
      ctx.globalCompositeOperation = 'source-over';
    }

    function activePoster() {
      for (var i = 0; i < posters.length; i++) {
        if (getComputedStyle(posters[i]).display !== 'none') return posters[i];
      }
      return posters[0];
    }

    function layout() {
      var w = stage.clientWidth, h = stage.clientHeight;
      if (!w || !h) return;
      var p  = activePoster();
      var pw = parseInt(p.getAttribute('data-w'), 10);
      var ph = parseInt(p.getAttribute('data-h'), 10);
      p.style.transform = 'scale(' + Math.max(w / pw, h / ph) + ')';
      if (open) return;
      dpr = Math.min(window.devicePixelRatio || 1, 2);
      W = Math.max(1, Math.round(w * dpr));
      H = Math.max(1, Math.round(h * dpr));
      canvas.width = W; canvas.height = H;
      torn.clear();
      paintFoil();
    }

    /* ── scratch ───────────────────────────────────────── */
    function scratchAt(x, y) {
      var R = Math.max(30, Math.min(W, H) * 0.095);
      ctx.globalCompositeOperation = 'destination-out';
      ctx.beginPath();
      for (var i = 0; i <= 11; i++) {
        var a = (i / 11) * Math.PI * 2;
        var r = R * (0.62 + Math.random() * 0.58);
        var px = x + Math.cos(a) * r, py = y + Math.sin(a) * r;
        if (i === 0) ctx.moveTo(px, py); else ctx.lineTo(px, py);
      }
      ctx.closePath(); ctx.fill();
      ctx.globalCompositeOperation = 'source-over';

      var cw = W / COLS, ch = H / ROWS;
      var c0 = Math.max(0, Math.floor((x - R) / cw)), c1 = Math.min(COLS - 1, Math.floor((x + R) / cw));
      var r0 = Math.max(0, Math.floor((y - R) / ch)), r1 = Math.min(ROWS - 1, Math.floor((y + R) / ch));
      for (var c = c0; c <= c1; c++) for (var rr = r0; rr <= r1; rr++) torn.add(rr * COLS + c);
      if (torn.size / TOTAL >= THRESHOLD) reveal();
    }

    function pos(e) {
      var b = canvas.getBoundingClientRect();
      return { x: (e.clientX - b.left) * dpr, y: (e.clientY - b.top) * dpr };
    }
    function down(e) {
      if (open) return;
      scratching = true;
      root.classList.add('is-tearing');
      try { canvas.setPointerCapture(e.pointerId); } catch (err) {}
      var p = pos(e); lastX = p.x; lastY = p.y; scratchAt(p.x, p.y);
    }
    function move(e) {
      if (!scratching || open) return;
      var p = pos(e);
      var steps = Math.max(1, Math.floor(Math.sqrt(Math.pow(p.x - lastX, 2) + Math.pow(p.y - lastY, 2)) / 14));
      for (var i = 1; i <= steps; i++) {
        scratchAt(lastX + ((p.x - lastX) * i) / steps, lastY + ((p.y - lastY) * i) / steps);
      }
      lastX = p.x; lastY = p.y;
    }
    function up() { scratching = false; }

    function reveal() {
      if (open) return;
      open = true; scratching = false;
      root.classList.add('is-open');
      try { sessionStorage.setItem('ffs20', '1'); } catch (err) {}
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'promo_reveal', {
          promo_id: 'free_ship_20',
          promo_name: 'Free shipping over $20 — scratch banner',
          layout: (stage.clientWidth > 760 ? 'laptop' : 'mobile')
        });
      }
    }

    /* ── wire up ───────────────────────────────────────── */
    canvas.addEventListener('pointerdown', down);
    canvas.addEventListener('pointermove', move);
    window.addEventListener('pointerup', up);
    window.addEventListener('pointercancel', up);
    if (skip) skip.addEventListener('click', reveal);

    layout();

    /* already scratched this visit, or motion is unwelcome — just show it */
    var seen = false;
    try { seen = sessionStorage.getItem('ffs20') === '1'; } catch (err) {}
    if (seen || window.matchMedia('(prefers-reduced-motion: reduce)').matches) reveal();

    var t;
    function onResize() { clearTimeout(t); t = setTimeout(layout, 150); }
    window.addEventListener('resize', onResize);
    window.addEventListener('orientationchange', onResize);

    /* breakpoint crossing swaps composition, so the foil must repaint */
    var mq = window.matchMedia('(max-width:760px)');
    if (mq.addEventListener) mq.addEventListener('change', layout);
    else if (mq.addListener) mq.addListener(layout);

    root.__ffs = {
      layout: layout,
      destroy: function () {
        window.removeEventListener('resize', onResize);
        window.removeEventListener('orientationchange', onResize);
        window.removeEventListener('pointerup', up);
        window.removeEventListener('pointercancel', up);
        if (mq.removeEventListener) mq.removeEventListener('change', layout);
        else if (mq.removeListener) mq.removeListener(layout);
        root.__ffs = null;
      }
    };
    instances.push(root);
  }

  function boot(scope) {
    var nodes = (scope || document).querySelectorAll('.ffs');
    Array.prototype.forEach.call(nodes, init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  /* theme editor lifecycle */
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    var n = e.target.querySelectorAll('.ffs');
    Array.prototype.forEach.call(n, function (el) { if (el.__ffs) el.__ffs.destroy(); });
  });
  document.addEventListener('shopify:section:select', function (e) {
    var n = e.target.querySelectorAll('.ffs');
    Array.prototype.forEach.call(n, function (el) { if (el.__ffs) el.__ffs.layout(); });
  });
})();
